export const injectedEnvironment: Record<string, string> = {
  REACT_APP_API_BASE_URL: "https://api.dev.boersenzeitung.sprylabprojects.com",
  REACT_APP_FILES_CDN_URL: "https://files.dev.boersenzeitung.sprylabprojects.com",
};
